<template>
  <CalicoBanner
    class="calico-ai-error body--medium"
    fixed
    variant="error"
  >
    {{ error }}
  </CalicoBanner>
</template>

<script>
import CalicoBanner from '@/components/calico/banner/index.vue'

export default {
  name: "CalicoAIError",
  components: {
    CalicoBanner
  },
  props: {
    error: {
      type: String,
      default: ""
    }
  },
}
</script>

<style scoped lang="scss">
</style>
